import { Header, HeadlineLink, HeadlineText } from './styled';

interface Props {
    text: string;
    search?: {
        text: string;
        url: string;
        onRouting: () => void;
    };
}

export function SearchbarHeader({ text, search }: Props) {
    return (
        <Header>
            <HeadlineText>{text}</HeadlineText>

            {search ? (
                <HeadlineLink href={search.url} onClick={search.onRouting}>
                    {search.text}
                </HeadlineLink>
            ) : null}
        </Header>
    );
}
